import { Info } from "@mui/icons-material";
import { Box, Container, Grid, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import StatsCard from "../../components/charts/StatsCard";
import HoverableButton from "../../components/layout/HoverableButton";
import NTMXGrid, { timestampFormatter } from "../../components/NTMXGrid";
import ResponsiveCircularLoading from "../../components/ResponsiveCircularLoading";
import { ARTICLE_ROUTE } from "../../constants/vendors";
import { useGetArticleVisualizations, useGetVendors } from "../../services/ContentManager";

export default function Advertisements({ uid }) {

    const { t } = useTranslation();
    const { status: vendorStatus, vendors: vendor } = useGetVendors(uid);
    const { status: visualizationStatus, visualizations } = useGetArticleVisualizations(uid);

    let cards = [
        {
            title: t('adPoints'),
            value: vendor.points,
        },
        {
            title: t('totalAmount'),
            value: visualizations.length === 0 ? 0 : visualizations.reduce((prev, current) => {
                return prev + current.cost;
            }, 0),
        },
    ];

    const columns = [
        {
            headerName: t('awardsFromCommunity'),
            field: 'articleTitle',
            renderCell: ({ row }) => (
                <Link href={ARTICLE_ROUTE + row.articleId} target="_blank" underline='none' >
                    <Box
                        sx={{
                            '& button': {
                                color: 'primary.main',
                                '&:hover': {
                                    color: 'secondary.main'
                                }
                            }
                        }}
                    >
                        <HoverableButton
                            item={{
                                icon: <Info />,
                                name: row.articleTitle
                            }}
                        />
                    </Box>

                </Link>
            ),
            minWith: 200,
            flex: 2
        }, {
            headerName: t('time'),
            field: 'timestamp',
            minWith: 180,
            flex: 2,
            ...timestampFormatter
        }, {
            headerName: t('cost'),
            field: 'cost',
            minWith: 100,
            flex: 1
        }
    ];

    return (<Grid container direction={'column'} rowGap={3} >
        <Grid item>
            <Container maxWidth="md">
                <Grid container alignItems={"stretch"} justifyContent={"space-between"}>
                    {
                        cards.map((c, k) =>
                            <Grid item lg={4} sm={6} xs={12} key={k} sx={{ p: 2 }}>
                                {
                                    !c.placeholder &&
                                    <StatsCard title={c.title} value={c.value} unit={c.unit} precision={c.precision}
                                        loading={vendorStatus === 'loading'} />
                                }
                            </Grid>
                        )
                    }
                </Grid>
            </Container>
        </Grid>

        <Grid item>
            {
                visualizationStatus === 'loading' ?
                    <ResponsiveCircularLoading />
                    :
                    <NTMXGrid
                        key={"vendor-article-visualization-table"}
                        columns={columns}
                        rows={visualizations || []}
                        title={t('visualizations')}
                        getRowId={(row) => visualizations && [row.timestamp, row.articleId]}
                    />
            }
        </Grid>
    </Grid>)
}